import AbTester from 'ab-tester.api.js';
import appConfig from 'src/utils/appConfig';
import babbelApi from 'src/libs/babbelApi';
import { reportAbTesterFailure } from 'src/utils/rollbar';

const isValidErrorResponse = (response) =>
  [404, 422].includes(response.statusCode);

const get = (params) =>
  new AbTester.ExperimentResult(babbelApi()).get(params);

export default (target, learnLanguageAlpha3) =>
  get({
    locale: appConfig.getMyConfig().locale,
    target,
    learnLanguageAlpha3
  }).then(
    ({ destination_value: destination }) => {
      if (destination) return destination;
      throw new Error('The response structure of ab tester has changed');
    },
    (response) => {
      if (!isValidErrorResponse(response)) reportAbTesterFailure(response);
      return null;
    }
  );
